"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Right = exports.Left = exports.Controls = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../shared/global-tokens");
var _jsxRuntime = require("react/jsx-runtime");
var StyledHeader = _styledComponents.default.header.withConfig({
  displayName: "TopNavigation__StyledHeader",
  componentId: "sc-1ql2b60-0"
})(["position:relative;box-sizing:border-box;flex-shrink:0;display:flex;justify-content:space-between;align-items:center;gap:", ";border-bottom:", " solid ", ";padding:0 ", ";background-color:", ";height:57px;z-index:50;"], _globalTokens.globalSpacing['600'], _globalTokens.globalBorder.width.thin, function (props) {
  return props.theme.sys.color.border.decorative;
}, _globalTokens.globalSpacing['600'], function (props) {
  return props.theme.sys.color.background.neutral['1'];
});
var TopNavigation = function TopNavigation(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledHeader, {
    children: children
  });
};
var StyledLeft = _styledComponents.default.div.withConfig({
  displayName: "TopNavigation__StyledLeft",
  componentId: "sc-1ql2b60-1"
})(["display:flex;justify-content:flex-start;align-items:center;gap:", ";flex:1 1 auto;height:100%;"], _globalTokens.globalSpacing['600']);
var Left = function Left(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLeft, {
    children: children
  });
};
exports.Left = Left;
var StyledRight = _styledComponents.default.div.withConfig({
  displayName: "TopNavigation__StyledRight",
  componentId: "sc-1ql2b60-2"
})(["display:flex;justify-content:flex-end;align-items:center;gap:", ";height:100%;"], _globalTokens.globalSpacing['600']);
var Right = function Right(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRight, {
    children: children
  });
};
exports.Right = Right;
var ControlsWrapper = _styledComponents.default.div.withConfig({
  displayName: "TopNavigation__ControlsWrapper",
  componentId: "sc-1ql2b60-3"
})(["display:flex;align-items:flex-end;height:inherit;"]);
var Controls = function Controls(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ControlsWrapper, {
    children: children
  });
};

// ONLY USED FOR STORYBOOK DOCUMENTATION
exports.Controls = Controls;
TopNavigation.Left = Left;
TopNavigation.Right = Right;
TopNavigation.Controls = Controls;
var _default = exports.default = TopNavigation;